// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { SortInvoicePaymentByField } from "@eisinc/XDL/interfaces";
import translate from "@insite/client-framework/Translate";

export const constants = {
    localStorage: {
        shouldLoadProductsForSubCategories: "shouldLoadProductsForSubCategories",
    },
};

export const ASCENDING_KEY = "ascending";
export const DESCENDING_KEY = "descending";
export enum InvoicePaymentAttributes {
    invoiceItemNumber = "invoiceItemNumber",
    invoiceNumber = "invoiceNumber",
    itemNumber = "itemNumber",
    purchaseOrderNumber = "purchaseOrderNumber",
    invoiceDate = "invoiceDate",
    calculatedDueDate = "calculatedDueDate",
    itemText = "itemText",
    invoiceAmount = "invoiceAmount",
    invoiceAmountDisplay = "invoiceAmountDisplay",
    transactionType = "transactionType",
    deactivated = "deactivated",
    sapFiDocumentType = "sapFiDocumentType",
    selected = "selected",
    amountToPay = "amountToPay",
    additionalComments = "additionalComments",
    additionalCommentsError = "additionalCommentsError",
    reasonForReducedPrice = "reasonForReducedPrice",
    reasonForReducedPriceError = "reasonForReducedPriceError",
    shouldShowOtherActions = "shouldShowOtherActions",
    dueDatePast = "dueDatePast",
    originalInvoiceNumber = "originalInvoiceNumber",
}

export const SORT_INVOICE_PAYMENT_BY_FIELD: SortInvoicePaymentByField = {
    originalInvoiceNumber: null,
    invoiceItemNumber: null,
    purchaseOrderNumber: null,
    invoiceDate: null,
    sapFiDocumentType: null,
    itemText: null,
    calculatedDueDate: ASCENDING_KEY,
    invoiceAmount: null,
};

export const DEFAULT_DUE_DATE_RANGE_KEY = "[0, Infinity]";
export const DEFAULT_INVOICE_PAYMENT_SORT_KEY = InvoicePaymentAttributes.calculatedDueDate;
export const DATE_SORT_KEYS = [InvoicePaymentAttributes.calculatedDueDate, InvoicePaymentAttributes.invoiceDate];
export const REASON_CODE_REQUIRED_FIELD_MESSAGE = translate("Reason Code is required");
export const COMMENT_REQUIRED_FIELD_MESSAGE = translate("Additional Comment is required");
export const DEFAULT_PAGE_SIZE = 48;

export const INVOICE_PAYMENT_HISTORY_SORT_KEYS = {
    PAYMENT_DATE: "paymentDate",
    INVOICE_NUMBER: "invoiceNumber",
    PO_REF_NUMBER: "po",
    TOTAL: "total",
};

export const INVOICE_PAYMENT_HISTORY_FILTER_KEYS = {
    FROM_DATE: "filters.fromDate",
    TO_DATE: "filters.toDate",
    INVOICE_NUMBER: "filters.invoiceNumber",
    PO_REF_NUMBER: "filters.poReference",
    TOTAL: "filters.total",
} as const;
